import { render, staticRenderFns } from "./InvitationLoginAccountOwner.vue?vue&type=template&id=1a6dc2fa&scoped=true&"
import script from "./InvitationLoginAccountOwner.vue?vue&type=script&lang=ts&"
export * from "./InvitationLoginAccountOwner.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationLoginAccountOwner.vue?vue&type=style&index=0&id=1a6dc2fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6dc2fa",
  null
  
)

export default component.exports